export const AB_TEST_BRANCH = 'AB_TEST_BRANCH';
export const ADS_AUDIENCE_MEMBERSHIP = 'ADS_AUDIENCE_MEMBERSHIP';
export const ALTER_LIST_MEMBERSHIP = 'ALTER_LIST_MEMBERSHIP';
export const AUTOMATION_EXTENSION = 'AUTOMATION_EXTENSION';
/**
 * @deprecated Keeping for backwards compatibility. Prefer the HubSpot-built
 *   Custom Action instead.
 */
export const CLASSIC_ADD_TO_LIST = 'CLASSIC_ADD_TO_LIST';
/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 * Keeping for backwards compatibility.
 */
export const CLASSIC_ALTER_LIST_MEMBERSHIP = 'CLASSIC_ALTER_LIST_MEMBERSHIP';
/**
 * @deprecated Keeping for backwards compatibility. Prefer the HubSpot-built
 *   Custom Action instead.
 */
export const CLASSIC_REMOVE_FROM_LIST = 'CLASSIC_REMOVE_FROM_LIST';
export const CLASSIC_ANCHORED_DELAY = 'CLASSIC_ANCHORED_DELAY';
export const CLASSIC_COPY_COMPANY_PROPERTY = 'CLASSIC_COPY_COMPANY_PROPERTY';
export const CLASSIC_ENROLL_IN_WORKFLOW = 'CLASSIC_ENROLL_IN_WORKFLOW';
export const CLASSIC_NOTIFICATION_EMAIL = 'CLASSIC_NOTIFICATION_EMAIL';
export const CLASSIC_VIRTUAL_ANCHORED_DELAY = 'CLASSIC_VIRTUAL_ANCHORED_DELAY';
export const CREATE_OBJECT = 'CREATE_OBJECT';
export const CREATE_SALESFORCE_CAMPAIGN = 'CREATE_SALESFORCE_CAMPAIGN';
export const CREATE_SALESFORCE_TASK = 'CREATE_SALESFORCE_TASK';
export const CUSTOM_CODE = 'CUSTOM_CODE';
export const DELAY = 'DELAY';
export const DELAY_UNTIL_DATE = 'DELAY_UNTIL_DATE';
export const EMAIL = 'EMAIL';
export const EMAIL_NOTIFICATION = 'EMAIL_NOTIFICATION';
export const EMPTY_ACTION = 'EMPTY_ACTION';
export const ENROLL_IN_FLOW = 'ENROLL_IN_FLOW';
export const FORMULA = 'FORMULA';
export const GO_TO = 'GO_TO';
export const IN_APP_NOTIFICATION = 'IN_APP_NOTIFICATION';
export const LIST_BRANCH = 'LIST_BRANCH';
export const ROTATE_OBJECT = 'ROTATE_OBJECT';
export const SEND_SMS_NOTIFICATION = 'SEND_SMS_NOTIFICATION';
/**
 * @deprecated Keeping for backwards compatibility. Prefer the HubSpot-built
 *   Custom Action instead.
 */
export const SET_MARKETING_STATUS = 'SET_MARKETING_STATUS';
export const SET_PROPERTY = 'SET_PROPERTY';
export const SLACK_NOTIFICATION = 'SLACK_NOTIFICATION';
export const STATIC_BRANCH = 'STATIC_BRANCH';
export const SUNSETTED_ACTION = 'SUNSETTED_ACTION';
export const TASK = 'TASK';
/**
 * @deprecated Keeping for backwards compatibility. Prefer the HubSpot-built
 *   Custom Action instead.
 */
export const UPDATE_EMAIL_SUBSCRIPTION = 'UPDATE_EMAIL_SUBSCRIPTION';
export const VIRTUAL_SCHEDULED_ENROLLMENT = 'VIRTUAL_SCHEDULED_ENROLLMENT';
export const WAIT_UNTIL = 'WAIT_UNTIL';
export const WEBHOOK = 'WEBHOOK';
export const WHILE_LOOP = 'WHILE_LOOP';

/**
 * Consolidated actions: One-to-many FE-to-BE actions.
 *
 * Prefix with ALL_ to indicate the one to many
 * relationship
 */
export const ALL_BRANCHES = 'ALL_BRANCHES';
export const ALL_DELAYS = 'ALL_DELAYS';